import jquerySelectric from 'selectric';
import '../form';


/**
 *  Javascript utilisé par le bloc "Actu stage" présent sur la home et sur les pages agences
 * 
 */
 (function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude, { bloc_actu_stage : Object.assign({}, w.Completude.bloc_actu_stage, {
                
        /**
         * Initialisation 
         */
        InitBlocStage() {
            //BUG Passe deux fois dans la function (pourquoi ??)            
            
            if (typeof(this.form)=='undefined') {
                var self = this;                
                // Active la validation sur le formulaire
                this.form = Completude.SetFormValidation(jQuery('#bloc-actu-stage-form'));

                //Desactive la liste des classes si on est pas sur un stage de visio
                if (!w.Completude.bloc_actu_stage.visio) {                    
                    jQuery('#bloc-actu-id-classe').prop('disabled','disabled').selectric('refresh');;                    
                }
                                
                // Agence par défaut
                if (jQuery('#bloc-actu-id-agence').val()!=="") {
                    Completude.bloc_actu_stage.ChargerListeClasse(jQuery('#bloc-actu-id-agence').val());
                } else {                    
                    // Capte les évènements "Agence Chargée"    
                    jQuery(document).on("agenceLoaded","",function(event,agency) {  
                        if (agency!=null) {
                            Completude.bloc_actu_stage.ChargerListeClasse(agency.Id);
                            jQuery('#bloc-actu-id-agence').val(agency.Id).selectric('refresh');
                        }                             
                    }); 
                }
                                
                // Clic sur Date et Tarif
                jQuery("#bloc-actu-stage-form-btn").on("click", function(e) {
                    e.preventDefault();
                    Completude.bloc_actu_stage.DatesEtTarif();
                }); 
                
                // Changement sur la liste déroulante des villes
                jQuery('#bloc-actu-id-agence').on('selectric-change', function(event, element, selectric) {                    
                    w.Completude.bloc_actu_stage.idAgence = jQuery(this).val();
                    if (w.Completude.bloc_actu_stage.idAgence && w.Completude.bloc_actu_stage.idPeriode) {
                        // Effectue une requete Ajax pour obtenir la liste des classes pour cette ville/periode                    
                        Completude.bloc_actu_stage.ChargerListeClasse(w.Completude.bloc_actu_stage.idAgence);
                        w.Completude.TagManagerTunnel('tarifStage/step-0',{"data-tracking-kpi": 'famille-stages-champ-ville-module-actualite'});
                    }
                });
            } 
                        
        }, 

        /**
         * Charge la liste des classes selon l'agence
         */
        ChargerListeClasse(idAgence) {
            if (!w.Completude.bloc_actu_stage.visio) {
                w.Completude.bloc_actu_stage.idAgence = idAgence;                
                jQuery("#bloc-actu-stage-form .form__body").loading(
                    jQuery.ajax({
                        url: disko_ajax_object.ajaxurl,
                        type: 'get',
                        data: {
                        'action': 'wp_bloc_actu_classes',
                        'IdAgence': idAgence,
                        'IdPeriode': w.Completude.bloc_actu_stage.idPeriode,                              
                        },
                        success: function (response) {
                            if (response.success) {
                                // Réactive la liste déroulante
                                $('#bloc-actu-id-classe').removeAttr('disabled');                                 
                                // Suppresssion des entrées précédentes                                
                                $('#bloc-actu-id-classe').find('option').remove().end().append('<option value="" selected></option>')
                                // Ajoute la liste des classes dans le select
                                $.each(response.data, function (i, item) {
                                    $('#bloc-actu-id-classe').append($('<option>', { 
                                        value: item.Id,
                                        text : item.Libelle 
                                    }));
                                });
                                // Refresh du composant selectric
                                $('#bloc-actu-id-classe').selectric('refresh');
                            }
                        },
                        error: function (data) {
                        console.log('Erreur…');                             
                        }
                }).promise());
            }
        },
        
        /**
         * Clic sur le bouton "Dates et Tarifs"
         */
        DatesEtTarif() {
            var self = this;                
            if (self.form.validate()) {
                w.Completude.TagManagerTunnel('tarifStage/step-0',{'data-tracking-kpi' : 'famille-stages-dates-tarifs-module-actualite-submit'});                
                var params = {
                    'IdAgence': w.Completude.bloc_actu_stage.idAgence,                         
                    'IdClasse' : jQuery('#bloc-actu-id-classe').val(),
                    'repeating' : jQuery('input[name=bloc-actu-redoublement]').prop('checked') ? "1" : "0"
                }
                window.location =  jQuery("#bloc-actu-stage-form")[0].action +'&'+ jQuery.param( params );
                    
            }
        }

    })});       
})(window);

jQuery(function() {
    try {
        if (jQuery("#section-bloc-actu-stage").length>0) {        
            window.Completude.bloc_actu_stage.InitBlocStage();         
        }
    }   
    catch (e) {
        console.error(e);
    }
});